import React from 'react'
import { runOnNextTick } from 'util/functions'
import copyToClipboard from 'copy-to-clipboard'
import NormalState from './NormalState'
import EditingState from './EditingState'

// eslint-disable-next-line no-unused-vars
import styles from './styles.less'

class Customer extends React.PureComponent {
  // HACK (jscheel): We don't have a single consistent action to reduce on for
  // changing the ticket (because we have different actions for if the ticket
  // has a draft or not), so we close the form here in the component instead.
  // Not ideal, but it works. We know that this component will unmount if the
  // customer has changed, because we key it to the customer id. If the ticket
  // changes but the customer does not
  componentDidMount() {
    const { isEditing } = this.props
    if (isEditing) this.closeForm()
  }

  componentDidUpdate(prevProps) {
    const { currentTicketId, isEditing } = this.props
    if (isEditing && prevProps.currentTicketId !== currentTicketId) {
      this.closeForm()
    }
  }

  // END HACK
  onEditClick = () => {
    const { openEditForm } = this.props
    openEditForm()
  }

  onCopyEmailToClipboard = () => {
    const { customer, doCopyCustomerEmail } = this.props
    copyToClipboard(customer.email)
    doCopyCustomerEmail(customer.email)
  }

  onCopyWebsiteToClipboard = () => {
    const { customer, doCopyCustomerWebsite } = this.props
    copyToClipboard(customer.website_url)
    doCopyCustomerWebsite(customer.website_url)
  }

  closeForm() {
    const { closeEditForm } = this.props
    runOnNextTick(closeEditForm)
  }

  render() {
    const {
      isEditing,
      onEditSave,
      closeEditForm,
      currentTicketId,
      ...rest
    } = this.props
    if (!rest.customer || !rest.customer.id) return null
    if (isEditing) {
      return (
        <EditingState
          initialValues={rest.customer}
          onSave={onEditSave}
          onSaveOK={closeEditForm}
          closeForm={closeEditForm}
          currentTicketId={currentTicketId}
          {...rest}
        />
      )
    }
    return (
      <NormalState
        customer={rest.customer}
        openEditForm={this.onEditClick}
        onCopyEmailToClipboard={this.onCopyEmailToClipboard}
        onCopyWebsiteToClipboard={this.onCopyWebsiteToClipboard}
      />
    )
  }
}

export default Customer
